var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],attrs:{"placeholder":_vm.placeholder},domProps:{"value":(_vm.text)},on:{"input":function($event){if($event.target.composing)return;_vm.text=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }